module.exports = __webpack_public_path__ + "img/15.20f5e349.jpg";